import {
    PRODUCT_FILTER_DESCRIPTORS,
    PRODUCT_RANGE_DESCRIPTORS,
} from '../productFilterDescriptors';
import type {
    ProductListRange,
    ProductRangeEnd,
    ProductRangeFilter,
} from '../productFilterTypes';
import { FILTERS_COPY, type FilterWords } from './filterLabels';
import { describeRangeValue } from './rangeValueMeta';

/** Range presentation comes from the same entries as URL and request rules. */
export const RANGE_FIELD_FORMAT = Object.fromEntries(
    PRODUCT_RANGE_DESCRIPTORS.map(({ group, range }) => [
        group,
        range.codec.fieldFormat,
    ]),
) as Record<ProductRangeFilter, Intl.NumberFormatOptions | undefined>;

export const RANGE_LEGEND_KEY = Object.fromEntries(
    PRODUCT_RANGE_DESCRIPTORS.map(({ group, range }) => [
        group,
        range.legendKey,
    ]),
) as Record<ProductRangeFilter, string>;

export const RANGE_END_LABEL_KEY: Record<ProductRangeEnd, string> = {
    min: `${FILTERS_COPY}.rangeMin`,
    max: `${FILTERS_COPY}.rangeMax`,
};

/** NaN is React Aria's controlled empty value, so Reset clears the input. */
export const toRangeFieldValue = (
    filter: ProductRangeFilter,
    bound: number | null,
): number =>
    bound === null
        ? Number.NaN
        : PRODUCT_FILTER_DESCRIPTORS[filter].range.codec.toField(bound);

/** Preserve the input seam's existing validation and money conversion. */
export const fromRangeFieldValue = (
    filter: ProductRangeFilter,
    value: number | undefined,
): number | null =>
    value === undefined || !Number.isFinite(value)
        ? null
        : PRODUCT_FILTER_DESCRIPTORS[filter].range.codec.fromField(value);

export const describeRangeTag = (
    filter: ProductRangeFilter,
    range: ProductListRange,
): FilterWords | null =>
    describeRangeValue(
        range,
        PRODUCT_FILTER_DESCRIPTORS[filter].range.codec.format,
    );
